import { useNavigate } from "react-router-dom";
import Footer from "../components/footer";
import '../styles/landing.css'
import Header from "../components/header";
import cassette from '../images/cassette.png'


const Landing = () => {
    const navigate = useNavigate();
    return (
      <>
      {window.innerWidth > 700? <Header/>: <div></div>}

      <div className="content">
<div className="subtitle">
<p className="createt">Create personalised mixtapes, dressed in retro</p>
</div>
      <button className="btn1" onClick={()=>{navigate('/create')}}>create your own mixtape</button>
      <img src={cassette} alt="" className="cst" />
         </div>

         {window.innerWidth > 700?  <Footer/>: <div></div>}

       
        
      </>
    );
  };
  
  export default Landing;
  